import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { useAppSelector } from "src/store";
import { createAssetFeatureOptionSaga } from "src/store/asset-features-options/saga";
import * as Yup from "yup";
import { AssetFeatureDetailDto } from "src/store/asset-features/type";

const AssetFeatureOptionCreateForm = ({
  onHide,
  open,
  onSuccessClick,
  feature,
}: {
  feature: AssetFeatureDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("AssetFeatureOption.CreateFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          PicklistOptionName: "",
          FeatureId: feature.Id,
          Translates: languages.map((x) => {
            return { LanguageId: x.EnumId, PicklistOptionName: "" };
          }),
        }}
        onSubmit={(values) => {
          dispatch(
            createAssetFeatureOptionSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          PicklistOptionName: Yup.string().required(
            t("Validation.Required").toString()
          ),
          FeatureId: Yup.string().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              PicklistOptionName: Yup.string().required(
                t("Validation.Required").toString()
              ),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "PicklistOptionName",
            label: t("AssetFeatureOption.OptionName").toString(),
          },
        ]}
      />
    </React.Fragment>
  );
};
export default AssetFeatureOptionCreateForm;
